import { isLocalUrl, openNewTab } from '../utils';

export default function () {
  const widgetName = 'ticketButton';
  const widgetOpts = ticketButtonOpts;

  const wrapContainerClass = 'ticket-container';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}">`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`#${widgetName}`).remove();
      } else {
        createCustomTicketBtn(data.items[0]);
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    const { Title, URL } = widgetData;
    const isLocal = isLocalUrl(URL);

    if (!URL) {
      $(`.${wrapContainerClass}`).remove();
    }

    $(`#${widgetName}`).replaceWith(
      `<a class="ticket-button" href="${URL}" ${openNewTab(isLocal)}>${Title}</a>`,
    );
  }
}
